// extracted by mini-css-extract-plugin
module.exports = {"contReel":"reels_contReel__yhMRs","reelModal":"reels_reelModal__Swycw"};